import React, { useContext, useEffect, useState } from "react";
import IGetOrderDTO from "../../../models/DTO/IGetOrderDTO";
import IOnGetOrderDTO from "../../../models/DTO/IOnGetOrderDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IOrder from "../../../models/IOrder";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OrderCreateInvoiceView from "./OrderCreateInvoiceView/OrderCreateInvoiceView";
import "./OrderCreateInvoice.scss";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import { OrderTotalsPanel } from "../../order_entry/OrderTotalsPanel/OrderTotalsPanel";
import EndpointsEnum from "../../../models/EndpointsEnum";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { useLocation } from "react-router-dom";

type Props = {
    /**
     * @deprecated
     */
    toggleMenu: () => void;
};

export const OrderCreateInvoice = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UserContext);
    const socket = useContext(SocketContext)!;
    const location = useLocation();

    const getOrderGuid = () => {
        const params = new URLSearchParams(location.search);
        return params.get("order");
    };

    const navItems: IBreadcrumbs[] = [
        { title: "Dashboard", url: "/dashboard" },
        { title: "Orders", url: "/orders" },
        {
            title: "Invoice",
            url: "",
        },
    ];

    const [order, setOrder] = useState<IOrder | null>(null);
    const [orderGuid, setOrderGuid] = useState<string | null>(getOrderGuid());

    const onGetOrder = (data: IOnGetOrderDTO) => {
        setOrder(data.order);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.OrderOnGetOrder, fn: onGetOrder }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getOrder();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const getOrder = () => {
        if (!orderGuid) {
            return;
        }

        const payload: IGetOrderDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuid,
        };

        socket.emit(EndpointsEnum.OrderGetOrder, payload);
    };

    if (!supplierModel || !userModel || !order) {
        return null;
    }

    return (
        <div className="OrderCreateInvoice col-12 mt-2 pb-5">
            {/*<OwViewOptionsPanel viewOptions={viewOptions} onChangeFn={this.handleSupplierChange}/>*/}

            <div className={"row mb-2 d-flex justify-content-between align-items-center flex-wrap"}>
                <div className={"d-inline-flex"}>
                    <Breadcrumbs hasTopMargin={false} navItems={navItems} />
                </div>
                <div className="d-flex justify-content-end align-items-center">
                    <OwPrintButton />
                </div>
            </div>

            <OrderCreateInvoiceView
                order={order}
                showPhone={true}
                showEmail={true}
                showSku={true}
                showUpc={true}
                supplierModel={supplierModel}
            />

            {order ? (
                <div className={"row"}>
                    <div className={"col-12 justify-content-end d-flex"}>
                        <OrderTotalsPanel
                            shouldHidePricingFn={() => {
                                return false;
                            }}
                            shouldHideTaxJarName={true}
                            order={order}
                            orderItemType={"standard"}
                            isReadOnly={true}
                            lineView={true}
                        />
                    </div>
                </div>
            ) : null}

            {supplierModel.invoice_footer ? <div className={"text-center"}>{supplierModel.invoice_footer}</div> : null}
        </div>
    );
};
